module.exports = __webpack_public_path__ + "img/rightarrow.e115f3b3.svg";